import {
  FileUploadFile,
  validateFileByProperties,
} from '@bbl-digital/snorre-v2'
import { FileWrapper } from '../types/types'
import { SimpleArchiveListDocumentModel } from 'shared/microServices/portalDocuments/models/SimpleArchiveListDocumentModel'

export const mapFileUploadFiles = (files: FileUploadFile[]): FileWrapper[] => {
  return files.map((file) => ({
    id: crypto.randomUUID() + ' ' + file.file.name,
    isLocal: true,
    isExisting: false,
    isArchive: false,
    file: file.file,
    name: file.file.name,
    validation: file.validation,
    size: file.file.size,
    mimeType: file.file.type,
  }))
}

export const mapArchiveFile = (
  file: SimpleArchiveListDocumentModel,
  maxSizeBytes?: number,
  accept?: string,
  reject?: string
): FileWrapper => {
  return {
    id: file.id,
    isLocal: false,
    isExisting: false,
    isArchive: true,
    file: undefined,
    name: file.filename,
    size: file.fileSize,
    mimeType: file.mimeType,
    validation: validateFileByProperties(
      file.filename,
      file.fileSize,
      file.mimeType,
      accept,
      maxSizeBytes,
      reject
    ),
  }
}
